import api from 'api';

import { defaultPagination } from './general';

type GetProjectType = {id: number | string}

export const listProjects = async (params) => api().get('/projects', { params: { ...defaultPagination, ...params } });

export const getProject = async ({ id }:GetProjectType) => api().get(`/projects/${id}`);

export const createProject = async ({ data }) => api().post('/projects', data);

export const updateProject = async ({ id, data }) => api().put(`/projects/${id}`, data);
